import ObjectCopyService from "external-services/object-copy-service/index";
import {clone, isEqual, isEmpty} from 'lodash-es';
import PouchLoadService from "external-services/pouch-load-service/index";

// requiring html templates so that hot reloading works
const template = require('./tablePlan.html');

const NS = 'TablePlan'; // jshint ignore:line

export function SumValidate() { // as sumValidate
  "ngInject";

  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, elem, attr, ctrl) {
      scope.$watch(attr.sumValidate, function (valuez) {
        if (valuez) {
          var values = clone(valuez);
          var sum = values.shift();
          var res = null;
          if ((values.length < 2 || values[1]) && sum != null) {
            _.each(values[0], function (val) {
              if (val != null) {
                res += val;
              }
            });
            if (res != null && res !== sum) {
              ctrl.$setValidity('sum', false);
              return;
            }
          }
        }
        ctrl.$setValidity('sum', true);
      }, true); //enable deep dirty checking
    }
  };
}


export function TablePlan() { // as tablePlan
  "ngInject";

  return {
    restrict: 'E',
    replace: true,
    template,
    scope: {
      config: '=',
      ready: '=',
      accessor: "=",
      onCancel: "=",
      onSave: "="
    },
    controller,
    controllerAs: 'vm',
    bindToController: true
  };

  function controller(
    SnapService, Plan, PlanConst, Command, tableHelpersService, Structure,
    $element, $timeout, $scope, $rootScope, $mdDialog,
    $q, $state, tablesService, unregister
  ) {
    "ngInject";

    const vm = this;

    vm.save = save;
    vm.cancel = cancel;
    vm.selectLayer = selectLayer;
    vm.showEditor = showEditor;
    vm.hideEditor = hideEditor;
    //functions - table
    vm.createTable = createTable;
    vm.rotateTable = rotateTable;
    vm.duplicateTable = duplicateTable;
    vm.removeTable = removeTable;
    //functions - structure
    vm.stackStructure = stackStructure;
    vm.removeStructure = removeStructure;
    vm.refreshStructure = refreshStructure;

    //model
    vm.tableEditor = {
      item: null,
      form: null,
      shapes: [{
        name: 'square',
        display: 'Square'
      },
        {
          name: 'rect',
          display: 'Rectangle'
        },
        {
          name: 'circle',
          display: 'Circle'
        }
      ],
      availableOptions: tablesService.availableOptions
    };

    vm.structureEditor = {
      item: null,
      form: null
    };

    vm.conflicts = false;

    // Copy reference of FloorPlan tables model, used for table unique name validator
    vm.tables = [];

    $scope.$watch('vm.tableEditor.item.capacity', function (val) {
      if (val && !vm.tableEditor.item.shape) {
        vm.tableEditor.item.shape = val > 4 ? 'rect' : 'square';
      }
    });

    $scope.$watch('vm.tableEditor.item.model.availableOption', function (val) {
      if (val) {
        tablesService.setBookingOptions(vm.tableEditor.item.model);
        vm.tableEditor.item.model.availableOption = val;
      }
    });

    var defaults = {
      addTable: true,
      onSelectedLayer: _.bind(function (name) {
        vm.layer = name;
      }, this),
      onSelectedElement: _.bind(function (element) {
        if (element.model.type === tableHelpersService.Type) {
          vm.tableEditor.existing = true;
        }
        this.showEditor(element);
      }, this),
      onDeselectedElement: _.bind(function () {
        this.hideEditor();
      }, this)
    };

    var listeners = [];
    listeners.push($scope.$on('$destroy', () => unregister(listeners)));

    //Listen for memento change, refresh undo/redo buttons status
    listeners.push($rootScope.$on('memento-changed', function (evt, info) {
      vm.mementoStatus = info;
      $scope.$evalAsync();
    }));

    //Initialize plan
    $timeout(function () {
      var options = _.extend({}, defaults, vm.config);
      vm.plan = new Plan(PlanConst.Mode.Layout, options);
      vm.plan.render(Snap($element.find('svg')[0]));
      vm.dom = vm.plan.dom;
      if (vm.accessor) {
        vm.accessor.enablePlan = enablePlan;
        vm.accessor.setStructures = setStructures;
        vm.accessor.setBookings = setBookings;
        vm.accessor.setSections = setSections;
        vm.accessor.setLayout = setLayout;
        vm.accessor.saveState = saveState;
        vm.accessor.selectLayer = selectLayer;
        vm.accessor.showConflicts = showConflicts;
      }
      vm.ready = true;
    }, 100);

    function enablePlan(enabled) {
      vm.plan.enable(enabled);
    }

    function showConflicts(conflicts) {
      vm.conflicts = vm.conflicts || !isEmpty(conflicts);
      vm.bookingConflicts = conflicts;
      $scope.$evalAsync();
    }

    function setStructures(structures) {
      vm.plan.setStructures(structures);
    }

    function setBookings(bookings) {
      vm.plan.setBookings(bookings);
    }

    function setSections(sections) {
      vm.section = sections[0];
      vm.plan.setSections(sections);
    }

    function setLayout(layout) {
      var done = $q.defer();
      vm.layout = layout;
      vm.plan.setLayouts([layout]).then(function () {
        updateTablesModel();
        done.resolve();
      });
      return done.promise;
    }

    function selectLayer(name) {
      vm.plan.selectLayer(name);
    }

    function saveState(command) {
      command = command || Command.createUserSave();
      vm.plan.saveState(command);
    }

    function save(evt) {
      if (typeof vm.onSave === 'function') {
        vm.onSave(vm.plan.getData(), evt);
      }
    }

    function cancel(evt) {
      if (typeof vm.onCancel === 'function') {
        vm.onCancel(evt);
      }
    }

    function showEditor(element) {
      switch (element.model.type) {
        case 'structure':
          vm.structureEditor.hasLabel = Structure.hasLabel(element.model.subType);
          vm.structureEditor.hasFillTheme = Structure.hasFillTheme(element.model.subType);
          vm.structureEditor.structureName = Structure.getTypeName(element.model.subType);
          vm.structureEditor.form.displayErrors = false;
          vm.structureEditor.form.$setPristine();
          vm.structureEditor.item = element;
          $scope.$evalAsync();
          break;
        case 'table':
          vm.tableEditor.form.displayErrors = false;
          vm.tableEditor.form.$setPristine();
          vm.tableEditor.item = element;
          tablesService.checkAvailableOptions(vm.tableEditor.item.model);
          $scope.$evalAsync();
          vm.tableEditor.listener = $scope.$watch('vm.tableEditor.item.model', watchTable, true);
          break;
      }
    }

    function hideEditor() {
      if (vm.structureEditor.item) {
        vm.structureEditor.item = null;
        $scope.$evalAsync();
      }
      if (vm.tableEditor.item) {
        vm.tableEditor.listener();
        vm.tableEditor.item = null;
        vm.plan.editorInvalid = false;
        $scope.$evalAsync();
      }
    }

    //Table Editor
    function createTable($event) {
      $event.stopPropagation(); //??
      //Create empty table
      vm.tableEditor.existing = false;
      var table = {
        markedToAdd: true,
        mode: PlanConst.Mode.Layout,
        model: {
          _id: PouchLoadService.getNewId(['table']),
          type: tableHelpersService.Type,
          rotation: 0
        }
      };
      this.showEditor(table);
    }

    //React to table model changes
    function watchTable(table, oldTable) {
      if (table) {
        var applyChange = table && vm.tableEditor.form.$dirty && vm.tableEditor.form.$valid && !isEqual(table, oldTable);
        vm.plan.editorInvalid = !vm.tableEditor.form.$valid;
        if (applyChange) {
          vm.tableEditor.form.$setPristine();
          if (vm.tableEditor.existing) {
            vm.plan.refreshTable(vm.tableEditor.item);
          } else {
            vm.tableEditor.existing = true;
            var newTable = vm.plan.addTable(vm.tableEditor.item.model);
            vm.plan.selectElement(newTable);
          }

          // Refresh internal tables model
          updateTablesModel();
        }
      }
    }

    function rotateTable() {
      if (vm.tableEditor.existing) {
        vm.tableEditor.item.model.rotation = vm.plan.rotateTable(vm.tableEditor.item);
      } else {
        if (vm.tableEditor.item.model.rotation === 225) {
          vm.tableEditor.item.model.rotation = -90;
        } else {
          vm.tableEditor.item.model.rotation += 45;
        }
      }
    }

    function duplicateTable() {
      if (vm.tableEditor.form.$valid) {
        var blueprint = ObjectCopyService.angularSafeCopy(vm.tableEditor.item.model);
        delete blueprint._id;
        delete blueprint._rev;
        delete blueprint.name;
        delete blueprint.position;
        blueprint.markedToAdd = true;
        var newTable = vm.plan.addTable(blueprint);
        vm.tableEditor.existing = true;
        vm.plan.selectElement(newTable);
        updateTablesModel();
      }
    }

    function removeTable(evt) {
      vm.plan.editorInvalid = false; //force
      if (vm.tableEditor.existing) {

        var tableModel = vm.tableEditor.item.model;
        var inJoins = [];
        var message = 'Are you sure you would like to remove this table ' + tableModel.name + '.';

        // Check for joined table
        if (vm.layout.tablesJoins) {
          for (var i = vm.layout.tablesJoins.length - 1; i >= 0; i--) {
            var tableJoin = vm.layout.tablesJoins[i];
            if (tableJoin && tableJoin.tables && tableJoin.tables.indexOf(tableModel._id) !== -1) {
              // the table was found in the join
              inJoins.push(i);
            }
          }
          // Ask user confirmation to proceed with table delete
          if (inJoins.length) {
            message += ' You will also be deleting ' + inJoins.length + ' join(s) that use this table.';
          }
        }

        var confirm = $mdDialog.confirm()
          .parent(angular.element(document.body))
          .title('Remove table?')
          .htmlContent(message)
          .ariaLabel('Remove table')
          .ok('Yes')
          .cancel('No')
          .targetEvent(evt);
        $mdDialog.show(confirm).then(function () {
          // Delete joins reference for this table
          if (inJoins.length) {
            for (var i = 0; i < inJoins.length; i++) {
              vm.layout.tablesJoins.splice(inJoins[i], 1);
            }
          }
          // Delete table from plan
          vm.plan.deleteTable(
            vm.tableEditor.item, //model
            true, //softDelete (mark table as toBeDeleted for service)
            false, //skipRefresh
            inJoins
          );
          updateTablesModel();
        });
      } else {
        vm.hideEditor();
      }
    }

    function stackStructure(direction) {
      if (vm.structureEditor.item) {
        vm.plan.stackStructure(vm.structureEditor.item, direction);
      }
    }

    function removeStructure() {
      if (vm.structureEditor.item) {
        vm.plan.removeStructure(vm.structureEditor.item, this.layer);
      }
    }

    function refreshStructure() {
      if (vm.structureEditor.item) {
        vm.plan.refreshStructure(vm.structureEditor.item);
      }
    }

    // Update the tables model reference (needed to validate the table unique name)
    function updateTablesModel() {
      var tables = _.pluck(vm.plan.tables, 'model');
      var validTables = _.filter(tables, function (model) {
        return !model.markedForDelete;
      });
      vm.tables = validTables;
    }
  }
}
